import { FaUsersCog, FaUserAlt, FaThLarge, FaHome } from "react-icons/fa";
import { Link, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

const ManagementLayout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Redirect to "user-info" if at the base "user-management" path
  if (pathname === "/department/user-management") {
    return <Navigate to="/department/user-management/user-info" />;
  }

  // Helper function to determine if a route is active
  const isActive = (path) => pathname.startsWith(path);

  return (
    <div className="flex flex-col h-screen">
      <div className="flex flex-1">
        {/* Sidebar */}
        <aside className="w-64 border-green-300 border-l  bg-green-200 p-6 hidden md:block">
          <div className="flex items-center mb-6">
            {/* <FaUsersCog className="text-3xl text-green-600 mr-3" /> */}
            <h1 className="text-2xl border-b-4 border-b-red-500 coda-regular font-bold text-green-800">Management</h1>
          </div>
          <nav>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/department/user-management/user-info"
                  className={`flex items-center font-semibold px-4 py-2 rounded ${isActive("/department/user-management/user-info")
                    ? "bg-green-700 text-white"
                    : "text-green-800 hover:text-green-600"
                    }`}
                >
                  <FaUserAlt className="mr-3 text-lg" />
                  <span className="coda-regular font-medium">All User Info</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/department/user-management/modules-info"
                  className={`flex items-center font-semibold px-4 py-2 rounded ${isActive("/department/user-management/modules-info")
                    ? "bg-green-700 text-white"
                    : "text-green-800 hover:text-green-600"
                    }`}
                >
                  <FaThLarge className="mr-3 text-lg" />
                  <span className="coda-regular font-medium">All Modules Info</span>
                </Link>
              </li>
            </ul>
          </nav>
        </aside>

        {/* Home Button */}
        <button
          onClick={() => navigate("/")}
          className="fixed bottom-6 left-6 flex items-center justify-center bg-green-50 border border-green-100 text-gray-900 p-3 rounded-full shadow-lg hover:bg-green-100 transition duration-300"
        >
          <FaHome className="text-3xl" />
        </button>

        {/* Outlet for Child Routes */}
        <main className="flex-1 h-screen overflow-y-auto bg-green-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ManagementLayout;
